<script setup lang="ts">
import { onMounted } from 'vue';
import { useRoute, router, ToastTypes } from '@hfc/ui-core';
import { UUID } from '@hfc/common/src/types/UUID';
import ChallengeQuestions from '@/shared/infrastructure/components/ChallengeQuestions.vue';
import { ChallengeType } from '@/application/shared/domain/ChallengeQuestionSettings';
import { APPLICATION_TYPES } from '@hfc/common/src/types/ApplicationTypes';
import { useAppStore } from '@/shared/infrastructure/composition/useAppStore';
import { useSmallBusinessStore } from '@/application/smallBusiness/infrastructure/composition/useSmallBusinessStore';

const { appStore } = useAppStore();
const { smallBusinessStore } = useSmallBusinessStore();

const route = useRoute();

const uuid = route.params.uuid as UUID;

const getApplicationAndContinue = async (): Promise<void> => {
  const result = await smallBusinessStore.getApplication(uuid);
  if (result && result.success) {
    router.push({ name: 'SmallBusinessApplication' });
  } else if (result && result.error) {
    appStore.addToast({ message: result.error.message ?? 'Error getting the application. Please try again.', type: ToastTypes.DANGER });
  }
};

onMounted(async (): Promise<void> => {
  smallBusinessStore.clearReviewData();
  await appStore.updateCustomTitleSlot('content');
  await appStore.updateCustomTitle('Find Affordable Business Health Plans');
});
</script>
<template>
  <div class="py-10">
    <h1 class="text-center">Challenge Questions</h1>
    <p class="text-center text-blue-500">In order to edit your business application, please validate the following information from your quote.</p>
  </div>
  <ChallengeQuestions
    :application-type="APPLICATION_TYPES.SMALL_BUSINESS"
    :local-config="{
      zip_code: true,
      email: true
    }"
    :challenge-type="ChallengeType.APPLICATION"
    :uuid="uuid"
    @challenge-success="getApplicationAndContinue"
    subtitle=""
    button-text="Edit Quote"
  />
</template>
